import React, { Component, Fragment } from "react";
import { ToastContainer } from "react-toastify";
import LoginTabset from "./loginTabset";
import "./login.css";
import { connect } from "react-redux";
import { setCurrentAdmin } from "../../actions";
import logo from "../../assets/images/dashboard/14.png";

class Login extends Component {
  render() {
    return (
      <div className="login-page-wrapper">
        <div className="login-left-panel">
          <div className="login-brand">
            <img src={logo} alt="Zapai" className="login-logo" />
            <p className="login-brand-subtitle">Admin Portal</p>
          </div>

          <div className="login-left-content">
            <h2 className="login-left-headline">
              Beautiful homes,<br />
              <em>curated for you.</em>
            </h2>
            <p className="login-left-desc">
              Source and manage premium home decor products from China,
              shipped directly to customers across Bangladesh.
            </p>
          </div>

          <div className="login-left-footer">
            <div className="login-left-stats">
              <div>
                <span className="login-stat-value">Decor</span>
                <span className="login-stat-label">Specialty</span>
              </div>
              <div>
                <span className="login-stat-value">B2C</span>
                <span className="login-stat-label">Platform</span>
              </div>
              <div>
                <span className="login-stat-value">24/7</span>
                <span className="login-stat-label">Support</span>
              </div>
            </div>
          </div>
        </div>

        <div className="login-right-panel">
          <div className="login-form-container">
            <div className="login-form-header">
              <p className="login-form-eyebrow">Zapai Admin</p>
              <h2 className="login-form-title">Welcome back</h2>
              <p className="login-form-sub">
                Sign in to manage orders and home decor inventory.
              </p>
            </div>
            <LoginTabset
              setCurrentAdmin={this.props.setCurrentAdmin}
              currentAdmin={this.props.currentAdmin2}
            />
          </div>
        </div>
        <ToastContainer />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentAdmin2: state.admins.currentAdmin,
});

export default connect(mapStateToProps, { setCurrentAdmin })(Login);
